export default class UseCaseModel {
  constructor() {
    this.company = ''; // string 要貸款哪間公司 必填
    this.cardless_code = ''; // string 產品代碼 必填
    this.supplier_business_type = ''; // string 業務別代碼 必填
    this.supplier_business_type_projects = ''; // string 專案代號 必填
    // string 貸款者身分證換補發地點
    // 10001:北縣,10002:宜縣,10003:桃縣,10004:竹縣,10005:苗縣,10006:中縣,10007:彰縣,
    // 10008:投縣,10009:雲縣,10010:嘉縣,10011:南縣,10012:高縣,10013:屏縣,10014:東縣,10015:花縣,
    // 10016:澎縣,10017:基市,10018:竹市,10020:嘉市,09007:連江,09020:金門,63000:北市,64000:高市,
    // 65000:新北市,66000:中市,67000:南市,68000:桃市
    this.issue_place = '';
    this.guarantor_issue_place = ''; // string 保證人身分證領補換地點
    // int 貸款者就業狀態 必填
    // 1.就業中
    // 2.待業中
    // 3.家管
    // 4.我是學生有兼差
    this.employment_status = '';
    // int 信用卡狀態
    // 1.沒辦過卡
    // 2.無卡自停
    // 3.協商繳款中
    // 4.其他
    this.creditcard_status = '';
    // string 信用卡狀態說明 視情況必填
    // 選擇4時必填
    this.creditcard_status_remark = '';
    // int 連帶保人選項 1.連帶保證人(需附保證人身分證正反面影本)
    // 2.配偶資料僅供參考
    // 3.法定代理人(需於法代欄位簽名)
    // 4.商品實際使用人
    this.guarantor_option = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/UseCaseModel.js